import {IntegrationType} from "@/shared/timrTypes";
import {Integrations} from "../integrations";
import {PanelBase} from "./panelBase";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";

export class Slack extends PanelBase {

	private static ADD_TO_SLACK_URL: string;
	private static APP_CONFIG_URL: string;

	constructor() {
		super();
	}

	public static setAddToSlackUrl(url: string) {
		Slack.ADD_TO_SLACK_URL = url;
	}

	public static getAddToSlackUrl(): string {
		return Slack.ADD_TO_SLACK_URL;
	}

	public static setAppConfigUrl(appId: string) {
		Slack.APP_CONFIG_URL = appId;
	}

	public static getAppConfigUrl(): string {
		return Slack.APP_CONFIG_URL;
	}

	// Called when the element is inserted in the DOM
	// DEVNOTE: No shadow DOM here, so we can use external css
	private connectedCallback() {
		const footerActions: string[] = [];
		if (Slack.getAddToSlackUrl()) {
			footerActions.push(`
				<a href="${Slack.getAddToSlackUrl()}" target="_blank" rel="noreferrer" class="btn btn-primary mt-10 mb-0 mr-10">
					${messages["integrations.slack.addToSlack"]}
				</a>
			`);
		}
		if (Slack.getAppConfigUrl()) {
			footerActions.push(`
				<a href="${Slack.getAppConfigUrl()}" target="_blank" rel="noreferrer" class="btn btn-primary mt-10 mb-0 mr-10">
					${messages["integrations.slack.viewConnectedUsers"]}
				</a>
			`);
		}

		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/slack.svg" alt="Slack" height="36px">`,
			footerHtml: footerActions.join("")
		});
		this.initListeners();
	}

	private initListeners() {
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.slack.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.SLACK, this.integration.id);
				}
			});
		});
	}

	protected updateBanner(): void {
		// Nothing to do here
	}
}
